import React, { FC, ReactNode } from 'react';
import { Flex, Typography } from 'antd';

const { Title } = Typography;

interface TableTitleProps {
    title: string;
    children?: ReactNode;
}

export const TableTitle: FC<TableTitleProps> = ({ title, children }) => {
    return (
        <Flex justify={'space-between'}>
            <Title style={{ margin: 0 }} level={4}>
                {title}
            </Title>
            {children ?? null}
        </Flex>
    );
};
